"use strict";

var _classCallCheck = require("/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SECP256K1Client = void 0;

var hmac_1 = require("@noble/hashes/hmac");

var sha256_1 = require("@noble/hashes/sha256");

var secp = require("@noble/secp256k1");

var ecdsaSigFormatter_1 = require("../ecdsaSigFormatter");

var errors_1 = require("../errors");

var utils_1 = require("@noble/hashes/utils"); // required to use noble secp https://github.com/paulmillr/noble-secp256k1


secp.utils.hmacSha256Sync = function (key) {
  var h = hmac_1.hmac.create(sha256_1.sha256, key);

  for (var _len = arguments.length, msgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    msgs[_key - 1] = arguments[_key];
  }

  msgs.forEach(function (msg) {
    return h.update(msg);
  });
  return h.digest();
};

var SECP256K1Client =
/*#__PURE__*/
function () {
  function SECP256K1Client() {
    _classCallCheck(this, SECP256K1Client);
  }

  _createClass(SECP256K1Client, null, [{
    key: "derivePublicKey",
    value: function derivePublicKey(privateKey) {
      var compressed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      if (privateKey.length === 66) {
        privateKey = privateKey.slice(0, 64);
      }

      if (privateKey.length < 64) {
        // backward compatibly accept too short private keys
        privateKey = privateKey.padStart(64, '0');
      }

      return (0, utils_1.bytesToHex)(secp.getPublicKey(privateKey, compressed));
    }
  }, {
    key: "signHash",
    value: function signHash(signingInputHash, privateKey) {
      var format = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'jose';

      // make sure the required parameters are provided
      if (!signingInputHash || !privateKey) {
        throw new errors_1.MissingParametersError('a signing input hash and private key are all required');
      }

      var derSignature = secp.signSync(signingInputHash, privateKey.slice(0, 64), {
        der: true,
        canonical: false
      });
      if (format === 'der') return (0, utils_1.bytesToHex)(derSignature);
      if (format === 'jose') return (0, ecdsaSigFormatter_1.derToJose)(derSignature, 'ES256');
      throw Error('Invalid signature format');
    }
  }, {
    key: "loadSignature",
    value: function loadSignature(joseSignature) {
      // create and return the DER-formatted signature bytes
      return (0, ecdsaSigFormatter_1.joseToDer)(joseSignature, 'ES256');
    }
  }, {
    key: "verifyHash",
    value: function verifyHash(signingInputHash, derSignatureBytes, publicKey) {
      // make sure the required parameters are provided
      if (!signingInputHash || !derSignatureBytes || !publicKey) {
        throw new errors_1.MissingParametersError('a signing input hash, der signature, and public key are all required');
      }

      return secp.verify(derSignatureBytes, signingInputHash, publicKey, {
        strict: false
      });
    }
  }]);

  return SECP256K1Client;
}();

exports.SECP256K1Client = SECP256K1Client;
SECP256K1Client.algorithmName = 'ES256K';